import React, { useState, useEffect } from "react";
import "./preferred-news.m.css";
import { STATIC_KEYWORDS } from "../../../../constants";

import DH from "../../../atoms/social-media-icons/DHIcon";
import Google from "../../../atoms/social-media-icons/Google";

const PreferredNewsButton = () => {
  const [toggle, setToggle] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setToggle((prev) => !prev);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    window.location.href =
      "https://www.google.com/preferences/source?q=deccan+herald";
  };

  return (
    <div styleName={`preferred-news-btn ${toggle ? "prefer-news-active" : "trusted-news-active"}`} onClick={handleClick}>
      <span
        styleName={`btn-text ${toggle ? "prefer-text" : "trusted-text"
          }`}
      >
        {toggle
          ? STATIC_KEYWORDS.PREFER
          : STATIC_KEYWORDS.TRUSTED}
      </span>

      <div styleName="btn-icon">
        {toggle ? <DH width={32} height={32} /> : <Google width={32} height={32} />}
      </div>
    </div>
  );
};

export default PreferredNewsButton;
